module.exports = __webpack_public_path__ + "static/img/balloons.ad6bdfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/balloons.png
// module id = 3dux
// module chunks = 0